import config from '../config.general';
import kpPassportLogoPng from './kpPassport/kpPassportLogo.png';
import mcProgressLogoPng from './mcProgress/mcProgressLogo.png';
import progressLogoPng from './progress/progressLogo.png';
import { DropDownListOption } from '../models/DropDownListOption';
import { UserOfficeCountries } from '../core/enums';
import { kellyPartnersPassportAppName, mcProgressAppName, betterOffAppName, usLabel } from '../core/constants';

interface AppVariantConfig {
	logo: string;
	registerPageSubtitle?: string;
	userCountriesData?: DropDownListOption<string>[];
}

const appVariants: Record<string, AppVariantConfig> = {
	[kellyPartnersPassportAppName]: {
		logo: kpPassportLogoPng,
		registerPageSubtitle: 'Enter your full name and email to get started.',
		userCountriesData: [
			{ text: UserOfficeCountries.AU, value: UserOfficeCountries.AU },
			{ text: usLabel, value: UserOfficeCountries.US }
		]
	},
	[mcProgressAppName]: {
		logo: mcProgressLogoPng
	},
	[betterOffAppName]: {
		logo: progressLogoPng,
		registerPageSubtitle: 'Enter your full name and Kelly+Partners email to create your account.',
		userCountriesData: [
			{ text: UserOfficeCountries.AU, value: UserOfficeCountries.AU },
			{ text: usLabel, value: UserOfficeCountries.US },
			{ text: UserOfficeCountries.UK, value: UserOfficeCountries.UK },
			{ text: UserOfficeCountries.IE, value: UserOfficeCountries.IE },
			{ text: UserOfficeCountries.HK, value: UserOfficeCountries.HK },
			{ text: UserOfficeCountries.IN, value: UserOfficeCountries.IN },
			{ text: UserOfficeCountries.PH, value: UserOfficeCountries.PH }
		]
	}
};

const getAppVariantConfig = () => {
	const baseConfig = appVariants[kellyPartnersPassportAppName];
	const variantConfig = appVariants[config.appName];

	/**
	 * Merge base config (Kelly+Partners Passport) with variant-specific config.
	 * Properties in variantConfig will override baseConfig properties.
	 * This allows each variant to only define what's different from the default,
	 * while inheriting all other properties from Kelly+Partners Passport.
	 *
	 * Example: McProgress only defines 'logo', so it inherits 'registerPageSubtitle' from base.
	 */
	return {
		...baseConfig,
		...variantConfig
	};
};

export default getAppVariantConfig;
